import * as types from '../mutation-types'

export default {
    namespaced: true,
    state:{
        visits: [],
        visitsOrder: []
    },

    actions:{
        fetchAll({ commit }){
            return window.axios.get('/visits').then((response) => {
                commit(types.STORE_VISITS, response.data);

                return response.data;
            })
        },

        fetchByDay({ commit }, { day }){
            return window.axios.get('/visits', {
                params:{
                    day
                }
            })
            .then((response) => {
                return response.data;
            })
        },

        delete({ commit }, { id }) {
            return window.axios.delete(`/visits/${id}`)
        },

        fetchByFilter({ commit }, { fromDate, toDate, entityType, regionIds, employeeIds, entityIds, entityName, specialtyId, workload, page, PerPage, OrderByWorkLoad, OrderByName, IsMedicalRep, visitId }){
            var urlSearchParams = new URLSearchParams();
            var params = { fromDate, toDate, entityType, entityName, specialtyId, workload, page, PerPage, OrderByWorkLoad, OrderByName, IsMedicalRep, visitId };

            Object.keys(params).forEach(param => {
                if (params[param] !== null && params[param] !== undefined) {
                    urlSearchParams.append(param, params[param]);
                }
            })
            regionIds.forEach(id => {
                urlSearchParams.append("regionIds", id);
            });

            employeeIds.forEach(id => {
                urlSearchParams.append("employeeIds", id);
            });

            entityIds.forEach(id => {
                urlSearchParams.append("entityIds", id);
            });

            return window.axios.get('/visits', {
                params: urlSearchParams
            })
            .then((response) => {
                return {
                    data: response.data,
                    total: parseInt(response.headers['x-pagination-total-count'])
                };
            })
        },

        fetchById({ commit }, { id }){
            return window.axios.get(`/visits/${id}`).then((response) => {
                return response.data;
            })
        },

        fetchVisitsWithoutPagination({ commit }, { fromDate, toDate, employeeId, regionIds, specialtyId }) {
            const urlSearchParams = new URLSearchParams();

            const params = { fromDate, toDate, employeeId, specialtyId };
            Object.keys(params).forEach(param => {
                if (params[param]) urlSearchParams.append(param, params[param]);
            })
            if (Array.isArray(regionIds)) {
                regionIds.forEach(id => urlSearchParams.append('regionIds', id))
            }

            return window.axios.get('/visits/BetweenTwoDates', { params: urlSearchParams }).then(({ data }) => {
                return data
            })
        },

        fetchVisitsOrder({ commit }, { FromDate, ToDate, RegionIds, EmployeeIds, Page, PerPage }) {
            const urlSearchParams = new URLSearchParams();
            var params = { FromDate, ToDate, Page, PerPage };
            Object.keys(params).forEach(param => {
                if (params[param]) urlSearchParams.append(param, params[param]);
            })
            if (Array.isArray(RegionIds)) {
                RegionIds.forEach(id => urlSearchParams.append('regionIds', id))
            }

            EmployeeIds.forEach(id => urlSearchParams.append('EmployeeIds', id))
			return window.axios.get('/Visits/OrderdVisits', {
                params: urlSearchParams
            }).then(({ data }) => {
                commit(types.STORE_VISITS_ORDER, data)
                return data
			})
		},

        updateVisit({ commit }, { id, entityId, otherSamples, notes, objections, nextVisitNotes, purpose, materialAmounts, unavailableMaterialIds, competitiveSamples, createdAt, coreMessage, durationInMinutes, residentDoctorNames })
        {
            return window.axios.put(`/visits/${id}`, { id, entityId, otherSamples, notes, objections, nextVisitNotes, purpose, materialAmounts, unavailableMaterialIds, competitiveSamples, createdAt, coreMessage, durationInMinutes, residentDoctorNames }).then(({ data }) => {
                return data
            })
        },

        EntitiesWithVisitsMarked({ commit }, {
            employeeId, workloadIds, typeId, specialtyId, specialtyIds, name, regionIds, nonDeleted, orderByWorkLoad, active, orderByName, orderByMedicalRepName,
            includeAddresses, includeContactInfo, withVisitsCount, visitsCountDescending,
            includeVisits, visitsFromDate, visitsToDate, visitsRegionIds, visitsSpecialtyId, page, perPage, employeeIds
        }) {
                const urlSearchParams = new URLSearchParams();
                var params = {
                    employeeId,
                    typeId,
                    specialtyId,
                    name,
                    nonDeleted,
                    orderByWorkLoad,
                    active,
                    orderByName,
                    orderByMedicalRepName,
                    includeAddresses,
                    includeContactInfo,
                    withVisitsCount,
                    visitsCountDescending,
                    page,
                    perPage,
                    includeVisits,
                    visitsFromDate,
                    visitsToDate,
                    visitsSpecialtyId
                };
                Object.keys(params).forEach(param => {
                    if (params[param] !== null && params[param] !== undefined) urlSearchParams.append(param, params[param]);
                })
                if (Array.isArray(workloadIds)) {
                    workloadIds.forEach(id => urlSearchParams.append('workloadIds', id))
                }
                if (Array.isArray(specialtyIds)) {
                    specialtyIds.forEach(id => urlSearchParams.append('specialtyIds', id))
                }

                if (Array.isArray(visitsRegionIds)) {
                    visitsRegionIds.forEach(id => urlSearchParams.append('visitsRegionIds', id))
                }

                if (Array.isArray(regionIds)) {
                    regionIds.forEach(id => urlSearchParams.append('regionIds', id))
                }

                if (Array.isArray(employeeIds)) {
                    employeeIds.forEach(id => urlSearchParams.append('employeeIds', id))
                }

                return window.axios.get('visits/EntitiesWithVisitsMark', { params: urlSearchParams }).then((data) => {
                    return {
                        data: data.data,
                        total: parseInt(data.headers['x-pagination-total-count'])
                    }
                })
            },
    },

    mutations:{
        [types.STORE_VISITS](state, visits){
            state.visits = visits;
        },

        [types.STORE_VISITS_ORDER] (state, visitsOrder) {
			state.visitsOrder = visitsOrder
		}
    },

    getters:{
        getVisitById: state => id => state.visits.find(c => c.id === id),
        getVisitOrderByMedicalRep: state => employeeId => state.visitsOrder.find(c => c.employeeId === employeeId)
    }
}
